import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const breadcrumbMap: Record<string, BreadcrumbItem[]> = {
  '/': [{ label: '首页' }],
  '/category': [{ label: '首页', path: '/' }, { label: '分类浏览' }],
  '/about': [{ label: '首页', path: '/' }, { label: '关于我们' }],
};

export default function Breadcrumbs() {
  const location = useLocation();
  const pathname = location.pathname;

  let items: BreadcrumbItem[] = [];

  if (pathname.startsWith('/article/')) {
    items = [{ label: '首页', path: '/' }, { label: '分类浏览', path: '/category' }, { label: '漫画详情' }];
  } else {
    items = breadcrumbMap[pathname] || [{ label: '首页' }];
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-400" aria-hidden="true">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              )}
              {item.path && index < items.length - 1 ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${index === items.length - 1 ? 'text-foreground-800 font-medium' : 'text-foreground-500'}`}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}